export default "__VITE_ASSET__1833e8aa__"